import { Link } from "react-router-dom";

interface MovieCardProps {
  id: string;
  title: string;
  year: number;
  genre: string;
  region: string;
  director: string;
  duration: number;
  poster: string;
}

export default function MovieCard({
  id,
  title,
  year,
  genre,
  region,
  director,
  duration,
  poster,
}: MovieCardProps) {
  return (
    <article className="group">
      <Link to={`/detail/movie/${id}`} className="block">
        <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-800/80 bg-background-800">
          <img
            src={poster}
            alt={`${title} 电影海报`}
            title={`${title} - 午夜视频高清午夜电影`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/15 to-transparent opacity-90" />
          <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-1 font-label text-[10px] tracking-wider text-background-950">
            {genre}
          </span>
          <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-md bg-background-950/70 px-2 py-1 text-[11px] text-foreground-200 backdrop-blur-sm">
            <i className="ri-time-line text-xs" />
            {duration} 分钟
          </span>
          <div className="absolute inset-x-0 bottom-0 flex translate-y-3 items-center gap-1.5 px-3 pb-9 text-[11px] text-accent-400 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <i className="ri-play-circle-line text-sm" />
            查看影片资料
          </div>
        </div>
        <h3 className="mt-3 truncate text-sm font-medium text-foreground-50 transition-colors group-hover:text-accent-400">
          {title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {year} · {region} · {director} 导演
        </p>
      </Link>
    </article>
  );
}